import { useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type PrimitiveAtom, useAtomValue } from 'jotai';
import React, { useCallback } from 'react';
import styled from 'styled-components';

export const GoogleAdsConsentModalFooter = ({
	closeModal,
	isRelevantAdsAllowedAtom,
	isUserDataSharingAllowedAtom,
	onPress
}: {
	closeModal: () => void;
	isRelevantAdsAllowedAtom: PrimitiveAtom<boolean>;
	isUserDataSharingAllowedAtom: PrimitiveAtom<boolean>;
	onPress: (isUserDataSharingAllowed: boolean, isRelevantAdsAllowed: boolean) => void;
}) => {
	const { $t } = useIntl();
	const isUserDataSharingAllowed = useAtomValue(isUserDataSharingAllowedAtom);
	const isRelevantAdsAllowed = useAtomValue(isRelevantAdsAllowedAtom);

	const onButtonPress = useCallback(() => {
		onPress(isUserDataSharingAllowed, isRelevantAdsAllowed);
		closeModal();
	}, [onPress, closeModal, isUserDataSharingAllowed, isRelevantAdsAllowed]);

	return (
		<S.Wrapper>
			<Button
				color="brand"
				fullWidth={false}
				testID="google-consent-button"
				text={$t('onboard.googleConsent.confirmButtonText')}
				variant="default"
				onClick={onButtonPress}
			/>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		justify-content: center;
	`;
}
